
import React from 'react'
import LanguageListTable from "./Componate/LanguageListTable";
import AddLanguge from "../LangugeAdd/AddLanguge";
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";
import { useRoleVerify } from "Common/RoleVerify";

const LanguageList = () => {
  const [Language, setLanguage] = React.useState([]); 
  const canShowAction = useRoleVerify("", ["can_create"]);

  return (
    <>
    {canShowAction && <AddLanguge   setLanguage={setLanguage} canShowAction={canShowAction}/>}
    <PageBody
     card={true}
     headerchildren={
        <HeadingOne>Language List</HeadingOne>
       }>
      <div className="col-12">
          <LanguageListTable  Language={Language} />
      </div>
    </PageBody>
    </>
    
  );
};

export default LanguageList;
